import React, { useEffect, useState } from "react";

import { Modal } from "@mui/material";
import { useTranslation } from "react-i18next";

import { CustomerPortalFooter } from "../CustomerPortalFooter";
import { ContainerFooter, LoadingModalWrapper, LoadingSpinner, Sentence } from "./styled";

export const CustomerPortalLoadingPortalSentences = () => {
  const { t: translate } = useTranslation();

  const sentences = [
    translate("packingItems"),
    translate("closingTheBoxes"),
    translate("listeningToBubbleWrapConfessions"),
    translate("parkingTheShip"),
    translate("talkingToTheFish"),
  ];

  const [dots, setDots] = useState("");
  const [currentSentence, setCurrentSentence] = useState<string>(translate("talkingToTheFish"));

  useEffect(() => {
    const dotInterval = setInterval(() => {
      setDots((prevDots) => (prevDots.length === 3 ? "" : `${prevDots}.`));
    }, 500);

    return () => {
      clearInterval(dotInterval);
    };
  }, []);

  useEffect(() => {
    if (dots === "") {
      setCurrentSentence((prev) => {
        const nextIndex = (sentences.indexOf(prev) + 1) % sentences.length;

        return sentences[nextIndex];
      });
    }
  }, [dots]);

  return (
    <Sentence>
      {currentSentence}
      {dots}
    </Sentence>
  );
};

export const CostumerPortalLoadingPortalModal = () => {
  return (
    <Modal open hideBackdrop={true}>
      <LoadingModalWrapper>
        <LoadingSpinner size={48} disableShrink />

        <CustomerPortalLoadingPortalSentences />

        <ContainerFooter>
          <CustomerPortalFooter />
        </ContainerFooter>
      </LoadingModalWrapper>
    </Modal>
  );
};
